<template>
  <b-sidebar :id="modalId" @hidden="addPublishingPageStyle()" right shadow>
    <template>
      <div class="header__crew">
        <h3>Page Styling</h3>
      </div>
      <div class="body__crew">
        <div class="list-wraper">
          <div class="list"></div>
        </div>
      </div>
    </template>
    <template>
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="4">
            <label for="Background-color">Background-color:</label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              v-model="pageStyle.backgroundColor"
              type="color"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4">
            <label for="Background-color">font-color:</label>
          </b-col>
          <b-col sm="8">
            <b-form-input v-model="pageStyle.color" type="color"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4">
            <label for="Background-color">font-size:</label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              v-model="pageStyle.fontSize"
              type="text"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4">
            <label for="Background-color">font-weight:</label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              v-model="pageStyle.fontWeight"
              type="number"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4">
            <label for="Background-color">Gradient Background</label>
          </b-col>
          <b-col sm="8">
            <b-form-checkbox
              v-model="isGradient"
              @change="isGradientChange"
              name="check-button"
              switch
            >
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="container" v-if="isGradient">
        <b-row class="my-1">
          <b-col sm="4"></b-col>
          <b-col sm="8">
            <transition-group name="flip-list" tag="ul">
              <li
                v-for="(color, index) in colors"
                :key="color.id"
                :class="{ shake: color.last }"
              >
                <div class="move">
                  <button
                    class="up"
                    @click="up(index)"
                    v-if="index > 0"
                  ></button>
                  <button
                    class="down"
                    @click="down(index)"
                    v-if="index < colors.length - 1"
                  ></button>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="color.hex"
                  maxlength="7"
                  :style="{ color: color.hex }"
                  :class="{ pin: color.disabled }"
                  :disabled="color.disabled"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                />
                <button
                  @click="lockColor(index)"
                  class="form-control"
                  :class="{ locked: color.disabled }"
                ></button>
              </li>
            </transition-group>
            <div class="button-group">
              <div>
                <button
                  @click="addColor"
                  id="add"
                  class="form-control"
                ></button>
                <transition name="fade">
                  <button
                    @click="removeColor"
                    class="form-control"
                    id="remove"
                    v-if="colors.length > 2"
                  ></button>
                </transition>
              </div>
              <button @click="generateGradient" class="form-control random">
                random
              </button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template #footer="{ hide }">
      <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <!-- <strong class="mr-auto">Footer</strong> -->
        <b-button size="sm" @click="hide">Save Style</b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    modalId: {
      type: String,
      required: false,
      default: "page-style-modal"
    },
    pageStyle: {
      type: Object,
      required: true
    },
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      colors: [
        { id: 0, hex: "#f12711", disabled: false },
        { id: 1, hex: "#f5af19", disabled: false }
      ],
      id: 2,
      isGradient: false
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    gradient() {
      let colors = "linear-gradient(45deg";
      this.colors.forEach(function(e) {
        colors += "," + e.hex;
      });
      colors += ")";
      return colors;
    }
  },
  watch: {
    pageStyle: {
      immediate: true,
      handler(val) {
        if (val.background && val.background != "") {
          this.isGradient = true;
          let backgroundData = val.background
            .replace(/linear-gradient\(45deg,/g, "")
            .replace(/\)/g, "");
          let splitData = backgroundData.split(",");
          let presentGradientColors = splitData.map((e, index) => {
            return { id: index, hex: e, disabled: false };
          });
          this.colors = presentGradientColors;
        } else {
          this.isGradient = false;
        }
      }
    },
    gradient: {
      immediate: true,
      handler(val) {
        if (this.isGradient) {
          this.pageStyle.background = val;
          this.pageStyle.fontWeight =
            typeof this.pageStyle.fontWeight == "string"
              ? parseInt(this.pageStyle.fontWeight)
              : this.pageStyle.fontWeight.toString();
        } else {
          this.pageStyle.background = "";
          this.pageStyle.fontWeight =
            typeof this.pageStyle.fontWeight == "string"
              ? parseInt(this.pageStyle.fontWeight)
              : this.pageStyle.fontWeight.toString();
        }
        return val;
      }
    }
  },
  methods: {
    isGradientChange(val) {
      if (val) {
        this.pageStyle.background = this.gradient;
        this.pageStyle.fontWeight =
          typeof this.pageStyle.fontWeight == "string"
            ? parseInt(this.pageStyle.fontWeight)
            : this.pageStyle.fontWeight.toString();
      } else {
        this.pageStyle.background = "";
        this.pageStyle.fontWeight =
          typeof this.pageStyle.fontWeight == "string"
            ? parseInt(this.pageStyle.fontWeight)
            : this.pageStyle.fontWeight.toString();
      }
    },
    addColor() {
      this.colors.push({ id: this.id, hex: this.randomHex(), disabled: false });
      this.id++;
    },
    removeColor() {
      if (this.colors[this.colors.length - 1].disabled == false) {
        if (this.colors.length > 2) {
          this.colors.pop();
        }
      }
    },
    generateGradient() {
      for (let i = 0; i < this.colors.length; i++) {
        if (this.colors[i].disabled === false)
          this.colors[i].hex = this.randomHex();
      }
    },
    lockColor(index) {
      this.colors[index].disabled === true
        ? (this.colors[index].disabled = false)
        : (this.colors[index].disabled = true);
    },
    randomHex() {
      return (
        "#" +
        Math.random()
          .toString(16)
          .slice(2, 8)
      );
    },
    up(index) {
      if (index > 0) {
        let temp = this.colors[index];
        this.$set(this.colors, index, this.colors[index - 1]);
        this.$set(this.colors, index - 1, temp);
      }
    },
    down(index) {
      if (index < this.colors.length - 1) {
        let temp = this.colors[index];
        this.$set(this.colors, index, this.colors[index + 1]);
        this.$set(this.colors, index + 1, temp);
      }
    },
    addPublishingPageStyle() {
      console.log("hiiii");
      console.log("this.pageStyle", this.pageStyle);
      const updates = {
        pageStyle: {
          style: this.pageStyle,
          _created_at: new Date(),
          _created_by: this.user.uid,
          name: "Mineral Blue"
        }
      };
      const payload = {
        id: this.publishing.id,
        updates: updates
      };

      this.$store.dispatch("user/updatePublishing", payload).then(res => {
        if (res) {
          this.$emit("refresh-publishing");
          this.$store.dispatch("user/showNotification", {
            title: "Publishings Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#page-style-modal {
  .ico {
    cursor: pointer;
  }
  .header__crew {
    position: relative;
    padding-bottom: 16px;
    h3 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 49px;
      text-align: center;
      color: #5b606c;
      margin: 0;
    }
    .ico__header {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: 35px 1fr 40px 60px;
      align-items: center;
      justify-items: flex-end;
    }
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-bottom: 1px solid #ddd;
    }
  }
  .body__crew {
    .list-wraper {
      display: flex;
      //   justify-content: center;
      align-items: center;
      flex-direction: column;
      max-height: 600px;
      overflow-y: scroll;
      padding: 0 12px;
      &::-webkit-scrollbar {
        width: 5px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        border-radius: 16px;
      }
      .list {
        height: 76px;
        cursor: pointer;
        width: 100%;
        padding: 16px;
        border-radius: 8px;
        display: grid;
        grid-template-columns: 44px 1fr 24px;
        grid-column-gap: 18px;
        align-items: center;
        margin: 4px 0;

        &.active {
          background: rgba(85, 126, 251, 0.1);
        }
        h5,
        h4 {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin-bottom: 2px;
          .highlight {
            font-weight: 800;
          }
        }
        h5 {
          font-size: 12px;
          line-height: 16px;
          margin: 0;
        }
        .name {
          font-size: 13px;
          font-weight: bold;
        }
        .ico {
          cursor: pointer;
        }
      }
    }
    .add-wraper {
      display: grid;
      grid-template-rows: 1fr 1fr 100px;
      label {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #474d52;
        margin-top: 25px;
      }
      input {
        border: none;
        &:focus {
          box-shadow: none;
        }
      }
      .confirm-user {
        display: block;
        margin-top: 25px;
        margin-left: 25px;
        .user-info-container {
          margin-top: 10px;
          padding: 8px;
          width: 400px;
          height: 66px;
          background: #f3f6f9;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .user-name {
            margin-left: 5px;
            width: 140px;
          }
          .user-img {
            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
            }
            .b-avatar {
              color: #8d99a0 !important;
              background-color: rgba(85, 126, 251, 0.1) !important;
            }
          }
          .buttons button {
            width: 80px;
            height: 44px;
            border-radius: 12px;
            margin-left: 5px;
            border: none;
          }
          .yes {
            background: var(--theme-color);
          }
          .no {
            color: var(--theme-color);
            background: rgba(85, 126, 251, 0.1);
          }
        }
        .db-name {
          font-size: 12px;
          font-weight: bold;
        }
      }
      .overlay-suggestions {
        border-radius: 5px;
        background: #f3f6f9;
        position: absolute;
        .list {
          cursor: pointer;
          padding: 12px;
          width: 470px;
          border-radius: 5px;
          .name {
            font-size: 13px;
            font-weight: bold;
          }
        }
        .list:hover {
          background-color: var(--theme-color);
        }
      }
      .overlay-roles-suggestions {
        top: 360px;
      }
    }
  }
  .header__search {
    display: flex;
    align-items: center;
    input {
      border: none;
      padding: 5px 10px;
      width: 100%;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      //   text-align: center;
      color: #5b606c;
    }
  }
  .container {
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    li {
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      position: relative;
    }

    li > button {
      border-radius: 0px 10px 10px 0px;
    }

    .button-group {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .button-group > div > button {
      // padding: 15px 20px;
    }
    .button-group > .random {
      max-width: 75px;
    }

    .button-group button {
      border-radius: 10px;
    }

    button {
      transition: 0.25s;
    }

    input,
    button {
      // all: unset;
    }

    li > button::before {
      font-family: "FontAwesome";
      content: "Lock";
    }

    .locked::before {
      content: "Lock";
    }

    input {
      // display: inline;
      // background: #ffffff;
      // padding: 15px;
      // max-width: 225px;
      // /* 	padding-left:0px; */
      // border-radius: 10px 0px 0px 10px;
      // transition: color 0.25s, background 0.25s ease-out;
    }

    li > button,
    .button-group button {
      background: #000000;
      color: #ffffff;
      // padding: 15px;
      cursor: pointer;
      min-width: 25px;
      max-width: 65px;
      text-align: center;
    }
    li > button,
    .button-group > div {
      display: flex;
    }

    .button-group button:hover {
      background: #ffffff;
      color: #000000;
    }

    li > button:hover::before {
      content: "Lock";
    }

    .locked:hover::before {
      content: "Locked";
    }

    .pin {
      background: #000000;
      color: #ffffff;
      /* 	transition:0.25s; */
      animation-duration: 0.05s;
      /*   	animation-name: fillIn; */
    }

    ul li i {
      content: "#";
      padding: 15px;
      padding-right: 0px;
      background: #ffffff;
      border-radius: 10px 0px 0px 10px;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    #add::before {
      font-family: "FontAwesome";
      content: "+";
    }

    #remove::before {
      font-family: "FontAwesome";
      content: "-";
    }

    #remove::before {
      font-family: "FontAwesome";
      content: "-";
    }

    .up::before {
      font-family: "FontAwesome";
      content: " ";
    }

    .down::before {
      font-family: "FontAwesome";
      content: " ";
    }

    .move button {
      font-size: 1.5rem;
      // cursor: pointer;
      // height: 100%;
      // width: 100%;
      // text-align: center;
      font-weight: 800;
      background: none;
      color: inherit;
      border: none;
      padding: 0;
      cursor: pointer;
      outline: inherit;
    }

    li .up::before {
      content: "↑";
      opacity: 0;
    }

    li:hover .up::before,
    li:hover .down::before {
      opacity: 1;
      transition: opacity 0.25s ease-out;
    }

    li .down::before {
      content: "↓";
      opacity: 0;
    }

    // .move button:hover {
    //   color: #ffffff;
    // }

    .move {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      right: calc(100%);
      height: 100%;
      width: 35px;
    }

    li.shake {
      animation-duration: 0.75s;
      animation-name: shake;
    }

    @keyframes shake {
      10%,
      90% {
        transform: translate3d(-1px, 0, 0);
      }

      20%,
      80% {
        transform: translate3d(2px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-4px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(4px, 0, 0);
      }
    }

    #credit {
      position: absolute;
      right: 10px;
      bottom: 10px;
      font-size: 0.8rem;
      text-transform: none;
    }

    #credit a {
      color: #000000;
    }

    .flip-list-move {
      transition: transform 0.25s;
    }

    .flip-list-leave-active {
      position: absolute;
      opacity: 0;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.25s;
    }
    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }
}
.user-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
